import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-black/10 bg-[#fdfbf7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <p className="font-mono text-[12px] tracking-[0.2em] uppercase text-[#1a1a1a]">
            Stories by Aradhana
          </p>
          <h3 className="font-serif text-3xl md:text-4xl leading-[1.05] tracking-tight text-[#1a1a1a] mt-6 max-w-md">
            A story is not complete when it’s told — it’s complete when it
            creates change.
          </h3>
        </div>

        <div className="md:col-span-2">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#4a4a4a]">
            Explore
          </p>
          <ul className="mt-5 space-y-3 font-sans text-[15px] text-[#1a1a1a]">
            <li>
              <a href="/#stories" data-testid="footer-link-stories">
                Signature stories
              </a>
            </li>
            <li>
              <a href="/#brands" data-testid="footer-link-brands">
                Brand work
              </a>
            </li>
            <li>
              <Link to="/press" data-testid="footer-link-press">
                Featured in
              </Link>
            </li>
            <li>
              <a href="/#collaborate" data-testid="footer-link-collaborate">
                Collaborate
              </a>
            </li>
            <li>
              <Link to="/foundation" data-testid="footer-link-foundation">
                Foundation
              </Link>
            </li>
            <li>
              <Link
                to="/patrons-monthly"
                data-testid="footer-link-international"
              >
                International Patrons
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#4a4a4a]">
            Foundation policies
          </p>
          <ul className="mt-5 space-y-3 font-sans text-[15px] text-[#1a1a1a]">
            <li>
              <Link
                to="/how-your-donation-is-used"
                data-testid="footer-link-donation-use"
              >
                Where your contribution goes
              </Link>
            </li>
            <li>
              <Link to="/refund-policy" data-testid="footer-link-refund">
                Refund &amp; cancellation
              </Link>
            </li>
            <li>
              <Link to="/terms" data-testid="footer-link-terms">
                Terms &amp; conditions
              </Link>
            </li>
            <li>
              <Link to="/privacy" data-testid="footer-link-privacy">
                Privacy policy
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#4a4a4a]">
            Find us
          </p>
          <div className="mt-5 flex items-center gap-5 text-[#1a1a1a]">
            <a
              href="https://www.instagram.com/storiesbyaradhana/"
              target="_blank"
              rel="noreferrer"
              data-testid="social-instagram"
              aria-label="Instagram"
              className="hover:text-[#2d4a22] transition-colors"
            >
              <Instagram size={20} strokeWidth={1.4} />
            </a>
            <a
              href="https://www.facebook.com/storiesbyaradhana"
              target="_blank"
              rel="noreferrer"
              data-testid="social-facebook"
              aria-label="Facebook"
              className="hover:text-[#2d4a22] transition-colors"
            >
              <Facebook size={20} strokeWidth={1.4} />
            </a>
            <a
              href="https://www.youtube.com/@storiesbyaradhanaa"
              target="_blank"
              rel="noreferrer"
              data-testid="social-youtube"
              aria-label="YouTube"
              className="hover:text-[#2d4a22] transition-colors"
            >
              <Youtube size={20} strokeWidth={1.4} />
            </a>
          </div>
          <p className="mt-8 font-sans text-sm text-[#4a4a4a] leading-relaxed">
            For collaborations, press, foundation enquiries, or to share a
            story:
            <br />
            <a
              href="mailto:hello@storiesbyaradhana.com"
              className="underline underline-offset-4 decoration-[#1a1a1a]/30 hover:decoration-[#1a1a1a]"
              data-testid="footer-email"
            >
              hello@storiesbyaradhana.com
            </a>
          </p>
        </div>
      </div>

      <div className="border-t border-black/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#4a4a4a]">
            © {new Date().getFullYear()} Stories by Aradhana
          </p>
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#4a4a4a]">
            Crafted with care — made in India
          </p>
        </div>
      </div>
    </footer>
  );
}
